import styled from "styled-components";

export const TopFilter = styled.div`
  display: flex;
  flex-direction: row;
  width: 50vw;
  > * {
    width: 50%;
    margin: 0 10px 10px 0;
  }
`;

export const TopFilter2 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start; /* Alinea los elementos a la izquierda */
  align-items: center; /* Alineación vertical centrada */
  width: 100%; /* Asegura que ocupe todo el ancho del contenedor */
  gap: 1rem; /* Espaciado uniforme entre elementos */

  > * {
    flex: 0.1; /* Cada elemento toma solo el espacio necesario */
    margin: 0 10px 10px 0
  }
`;

export const Iframe = styled.iframe`
  height: 120vh;
`
